import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const accessToken = localStorage.getItem('token');
  
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

export default ProtectedRoute;
